<template>
    <div class="clinic-categories">
        <div class="content-container row">
            <div class="col-12 d-flex justify-content-center" v-if="loading">
                <b-spinner></b-spinner>
            </div>
            <div v-for="(category, i) in categories" :key="i" class="card-container col-12 col-sm-6 col-md-4 px-5 py-5" v-else>
                <div class="category-card" @click="selectCategory(category.c_id)">
                    <div v-if="category.c_featured_img" class="category-image mb-3" :style="'background-image: url(' + category.c_featured_img+ ')'"></div>
                    <div class="category-image mb-3" style="background-image: url('https://healthcoach-media.com/res/surge/Exercises/Images/24_Push_Ups.jpg')" v-else>
                    </div>
                    <div class="card-content px-4">
                        <h3 class="brand-primary py-2">{{category.c_label}}</h3>
                        <p v-if="category.c_description">{{category.c_description}}</p>
                        <p v-else>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    </div>
                    <b-button @click="selectCategory(category.c_id)" class="cta-button availability-button px-5 py-3 mb-5 mx-3">View Availability</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import config from "@/config/constants"
    export default {
        name: "ClinicCategories",
        data(){
            return{
                categories: null,
                loading: true
            }
        },
        mounted() {
            this.getCategories()
        },
        methods:{
            async getCategories(){
                //this.categories = [{"c_id":1,"c_label":"Chartered Physiotherapist","c_description":"Whether you would like to advance your current rehab, get help with any new \"posture pain\" that everyone seems to be getting from their new home working desk set up, or have a new injury that you would like to get help with, our Virtual Physio service is easy to use, clinically effective and suitable for most issues.","c_featured_img":"https:\/\/healthcoach-media.com\/res\/surge\/online_clinics\/Physiotherapy.jpg","c_events_count":2},{"c_id":2,"c_label":"Dietician","c_description":"We appreciate that at times like this, food and nutrition may not be at the top of your priority list, however, it's now more important than ever that you do what you can to keep your immune system in tip top shape. Improving your diet, moving your body regularly, managing stress and getting adequate sleep are just some of the areas that you can focus on to keep yourself feeling well.","c_featured_img":"http:\/\/healthcoach-media.com\/res\/surge\/online_clinics\/Dietician.jpg","c_events_count":1},{"c_id":3,"c_label":"Qualified Financial Advisor","c_description":"As well as Health crisis, COVID-19 is an economic crisis too. Book a video session with an independent and Qualified Financial Advisor who help you come to terms with the financial impacts of COVID-19.","c_featured_img":"https:\/\/healthcoach-media.com\/res\/surge\/online_clinics\/Qualified-Financial-Advisor.jpg","c_events_count":1},{"c_id":4,"c_label":"Parenting Coach","c_description":"Many parents are balancing a new work from home routine with managing have their kids in the house too. Lots of new stressors have been created as a parent from COVID-19 so book a consultation with one of our parenting experts today. ","c_featured_img":"http:\/\/healthcoach-media.com\/res\/surge\/online_clinics\/Parenting%20Coach.jpg","c_events_count":1},{"c_id":6,"c_label":"Healthcoach","c_description":"Our qualified Healthcoaches will work with you to create a personalised health programme to help and support you achieve your individual health goals across Fitness, Nutrition & Wellbeing","c_featured_img":"http:\/\/healthcoach-media.com\/res\/surge\/online_clinics\/Healthcoach.jpg","c_events_count":1}]
                //this.loading = false
                const payload = {
                    user_id: this.$store.getters.user_id
                }
                let res = await this.axios.post(config.api_env + '/application/api/g/global-events/get-categories', payload, config.options)
                if (res.data.success){
                    this.categories = res.data.categories.reverse()
                    this.loading = false
                }else if(res.data.err && res.data.err.includes('3994')){
                    this.$store.dispatch('logout')
                    this.$router.push("/login");
                }
            },
            selectCategory(c_id){
                this.$emit('select-category', c_id)
            }
        }
    }
</script>

<style scoped lang="less">
    .clinic-categories{
        .content-container{
            align-items: stretch;
        }
        .card-container{
            display: flex;
            justify-content: center;
        }
        .category-card{
            display: flex;
            flex-direction: column;
            max-width: 330px;
            width: 100%;
            align-items: center;
            justify-content: flex-start;
            text-align: center;
            border-radius: 10px;
            box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
            transition: 0.3s ease-out;
            cursor: pointer;
            &:hover{
                box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.6)
            }
            .category-image{
                height: 150px;
                width:100%;
                border-radius: 10px 10px 0 0;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
            }
            .card-content{
                width: 100%;
                h3{
                    font-size: 1.9rem;
                }
                p{
                    text-align: left;
                    font-size: 1.3rem;
                }
            }
            .availability-button{
                margin-top: auto;
            }
        }
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            .category-card {
                display: block;
                position: relative;
                padding-bottom: 50px;
                .card-content{
                    padding-bottom: 30px;
                }
                .availability-button{
                    position: absolute;
                    bottom: 0;
                    left: 20%;
                    transform: translateX(-10%);
                }
            }
        }
    }
</style>